const editDisable = (params) => Object.keys(params.row?.rigs ?? {}).length > 0;

const columns = (renderActions, RenderDateTimeCell, renderValueCell, renderTargetAnswersCell, renderRigsToTargetCell) => [
  {
    field: 'question',
    headerName: 'Question',
    width: 390,
    editable: true,
    headerAlign: 'center',
    align: 'center',
    renderEditCell: renderValueCell,
  },
  {
    field: 'referenceCategory',
    headerName: 'Search Category',
    headerAlign: 'center',
    align: 'center',
    width: 250,
    editable: (params) => !editDisable(params),
    valueFormatter: (params) => {
      if (Array.isArray(params.value)) {
        return params.value.join(', ');
      }
      return params.value;
    },
    renderEditCell: renderValueCell,
  },
  {
    field: 'targetSpend',
    headerName: 'Target Spend',
    headerAlign: 'center',
    align: 'center',
    width: 150,
    editable: (params) => !editDisable(params),
    valueFormatter: (params) => `$${params.value}`,
    type: 'number',
    renderEditCell: renderValueCell,
  },
  {
    field: 'startDate',
    headerName: 'Start Date',
    width: 250,
    editable: (params) => !editDisable(params),
    headerAlign: 'center',
    align: 'center',
    hide: false,
    renderEditCell: (params) => <RenderDateTimeCell {...params} />,
    valueFormatter: (params) => params?.value || '',
  },
  {
    field: 'endDate',
    headerName: 'End Date',
    width: 250,
    editable: (params) => !editDisable(params),
    headerAlign: 'center',
    align: 'center',
    hide: false,
    renderEditCell: (params) => <RenderDateTimeCell {...params} />,
    valueFormatter: (params) => params?.value || '',
  },
  {
    field: 'rigsBelowTarget',
    headerName: 'Rig Count',
    headerAlign: 'center',
    align: 'center',
    width: 150,
    editable: false,
    renderCell: renderRigsToTargetCell
  },
  {
    field: 'answers',
    headerName: 'Responses',
    sortable: false,
    filterable: false,
    width: 140,
    align: 'center',
    headerAlign: 'center',
    renderCell: renderTargetAnswersCell,
  },
  {
    field: 'actions',
    headerName: 'Actions',
    width: 150,
    headerAlign: 'center',
    align: 'center',
    renderCell: renderActions,
  },
];
export default columns;
